import createReducer from 'utils/createReducer';

const INIT_STATE = {
  venues: new Map(),
  selectedVenue: null,
};

const SET_VENUES = 'point-of-interest/venues/SET_VENUES';
const SET_CLEAR = 'point-of-interest/venues/SET_CLEAR';
const SET_SELECTED_VENUE = 'point-of-interest/venues/SET_SELECTED_VENUE';

const reducer = createReducer(INIT_STATE, {
  [SET_VENUES](state, payload) {
    return {
      ...state,
      venues: payload.venues,
    };
  },
  [SET_CLEAR]() {
    return INIT_STATE;
  },
  [SET_SELECTED_VENUE](state, payload) {
    return {
      ...state,
      selectedVenue: payload.selectedVenue,
    };
  },
});

const setVenues = (venues) => ({
  type: SET_VENUES,
  payload: { venues },
});

const setClear = () => ({
  type: SET_CLEAR,
  payload: {},
});

const setSelectedVenue = (selectedVenue) => ({
  type: SET_SELECTED_VENUE,
  payload: { selectedVenue },
});

export default reducer;
export { INIT_STATE, setVenues, setClear, setSelectedVenue };
